import React from 'react';


export const MissingPage = () => (
  <div>
    <h2>There is no such page.</h2>
  </div>
);
